import React from 'react';
import '../LegalPages.css';
import Footer from '../../../components/layout/Footer/Footer';
import Header from '../../../components/layout/Header/Header';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
  return (
    <div className="legal-page">
      <div className="classjustforheadercolor"></div>
      <Header />
      
      {/* Hero Section */}
      <section className="legal-hero">
        <div className="container">
          <div className="legal-hero__content">
            <div className="hero-badge">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
              </svg>
              <span>Politique de Confidentialité</span>
            </div>
            
            <h1 className="legal-hero__title">
              Protection de Vos <span className="title-highlight">Données Personnelles</span>
            </h1>
            
            <p className="legal-hero__subtitle">
              Chez BuroTime, la confidentialité et la sécurité de vos données sont notre priorité absolue.
            </p>
            
            <div className="legal-meta">
              <div className="legal-meta__item">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="10"/>
                  <path d="M12 6v6l4 2"/>
                </svg>
                <span>Dernière mise à jour : 18 Novembre 2025</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="legal-content">
        <div className="container">
          <div className="legal-grid">
            {/* Main Content */}
            <div className="legal-main">
              <div className="legal-section">
                <h2 className="legal-section__title">1. Introduction</h2>
                <p className="legal-section__text">
                  BuroTime s'engage à protéger la confidentialité de vos informations personnelles. 
                  Cette politique de confidentialité explique comment nous collectons, utilisons, 
                  partageons et protégeons vos données personnelles conformément à la législation 
                  algérienne en vigueur.
                </p>
              </div>

              <div className="legal-section">
                <h2 className="legal-section__title">2. Données Collectées</h2>
                <p className="legal-section__text">
                  Nous collectons différents types de données pour améliorer nos services :
                </p>
                
                <div className="legal-subsection">
                  <h3 className="legal-subsection__title">2.1 Données d'Identification</h3>
                  <ul className="legal-list">
                    <li>Nom et prénom</li>
                    <li>Adresse email</li>
                    <li>Numéro de téléphone</li>
                    <li>Adresse de livraison et de facturation</li>
                    <li>Informations de l'entreprise (pour les clients professionnels)</li>
                  </ul>
                </div>

                <div className="legal-subsection">
                  <h3 className="legal-subsection__title">2.2 Données de Navigation</h3>
                  <ul className="legal-list">
                    <li>Adresse IP</li>
                    <li>Type de navigateur</li>
                    <li>Pages visitées</li>
                    <li>Durée de visite</li>
                    <li>Cookies et technologies similaires</li>
                  </ul>
                </div>

                <div className="legal-subsection">
                  <h3 className="legal-subsection__title">2.3 Données de Transaction</h3>
                  <ul className="legal-list">
                    <li>Historique des commandes</li>
                    <li>Montants des achats</li>
                    <li>Mode de paiement utilisé</li>
                    <li>Statut de livraison</li>
                  </ul>
                </div>
              </div>

              <div className="legal-section">
                <h2 className="legal-section__title">3. Utilisation des Données</h2>
                <p className="legal-section__text">
                  Vos données personnelles sont utilisées pour :
                </p>
                <ul className="legal-list">
                  <li>Traiter et livrer vos commandes</li>
                  <li>Vous contacter concernant vos commandes</li>
                  <li>Améliorer nos produits et services</li>
                  <li>Personnaliser votre expérience sur notre site</li>
                  <li>Vous envoyer des communications marketing (avec votre consentement)</li>
                  <li>Prévenir la fraude et garantir la sécurité</li>
                  <li>Respecter nos obligations légales</li>
                </ul>
              </div>

              <div className="legal-section">
                <h2 className="legal-section__title">4. Partage des Données</h2>
                <p className="legal-section__text">
                  Nous ne vendons jamais vos données personnelles. Nous pouvons partager vos 
                  informations uniquement dans les cas suivants :
                </p>
                <ul className="legal-list">
                  <li>
                    <strong>Prestataires de services :</strong> Livraison, paiement, hébergement web
                  </li>
                  <li>
                    <strong>Obligations légales :</strong> Autorités compétentes sur demande légale
                  </li>
                  <li>
                    <strong>Protection des droits :</strong> Pour protéger nos droits et ceux de nos clients
                  </li>
                </ul>
              </div>

              <div className="legal-section">
                <h2 className="legal-section__title">5. Sécurité des Données</h2>
                <p className="legal-section__text">
                  Nous mettons en œuvre des mesures de sécurité techniques et organisationnelles 
                  pour protéger vos données :
                </p>
                <ul className="legal-list">
                  <li>Cryptage SSL/TLS pour toutes les transmissions de données</li>
                  <li>Serveurs sécurisés avec pare-feu avancés</li>
                  <li>Accès restreint aux données personnelles</li>
                  <li>Audits de sécurité réguliers</li>
                  <li>Formation du personnel sur la protection des données</li>
                </ul>
              </div>

              <div className="legal-section">
                <h2 className="legal-section__title">6. Vos Droits</h2>
                <p className="legal-section__text">
                  Conformément à la législation algérienne, vous disposez des droits suivants :
                </p>
                
                <div className="legal-rights">
                  <div className="legal-right-item">
                    <div className="legal-right-item__icon">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                        <path d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
                      </svg>
                    </div>
                    <div className="legal-right-item__content">
                      <h4>Droit d'Accès</h4>
                      <p>Consulter vos données personnelles</p>
                    </div>
                  </div>

                  <div className="legal-right-item">
                    <div className="legal-right-item__icon">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/>
                        <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/>
                      </svg>
                    </div>
                    <div className="legal-right-item__content">
                      <h4>Droit de Rectification</h4>
                      <p>Corriger vos données inexactes</p>
                    </div>
                  </div>

                  <div className="legal-right-item">
                    <div className="legal-right-item__icon">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <polyline points="3 6 5 6 21 6"/>
                        <path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2"/>
                      </svg>
                    </div>
                    <div className="legal-right-item__content">
                      <h4>Droit à l'Effacement</h4>
                      <p>Supprimer vos données personnelles</p>
                    </div>
                  </div>

                  <div className="legal-right-item">
                    <div className="legal-right-item__icon">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <circle cx="12" cy="12" r="10"/>
                        <line x1="15" y1="9" x2="9" y2="15"/>
                        <line x1="9" y1="9" x2="15" y2="15"/>
                      </svg>
                    </div>
                    <div className="legal-right-item__content">
                      <h4>Droit d'Opposition</h4>
                      <p>Refuser le traitement de vos données</p>
                    </div>
                  </div>
                </div>

                <p className="legal-section__text">
                  Pour exercer vos droits, contactez-nous à : <strong>privacy@burotime.dz</strong>
                </p>
              </div>

              <div className="legal-section">
                <h2 className="legal-section__title">7. Cookies</h2>
                <p className="legal-section__text">
                  Notre site utilise des cookies pour améliorer votre expérience. Pour plus 
                  d'informations, consultez notre <Link to="/cookies" className="legal-link">politique de cookies</Link>.
                </p>
              </div>

              <div className="legal-section">
                <h2 className="legal-section__title">8. Conservation des Données</h2>
                <p className="legal-section__text">
                  Nous conservons vos données personnelles aussi longtemps que nécessaire pour :
                </p>
                <ul className="legal-list">
                  <li>Fournir nos services</li>
                  <li>Respecter nos obligations légales (5 ans minimum pour les données de facturation)</li>
                  <li>Résoudre les litiges</li>
                  <li>Faire respecter nos accords</li>
                </ul>
              </div>

              <div className="legal-section">
                <h2 className="legal-section__title">9. Modifications</h2>
                <p className="legal-section__text">
                  Nous nous réservons le droit de modifier cette politique de confidentialité à 
                  tout moment. Les modifications seront publiées sur cette page avec une date de 
                  mise à jour révisée. Nous vous encourageons à consulter régulièrement cette page.
                </p>
              </div>

              <div className="legal-section">
                <h2 className="legal-section__title">10. Contact</h2>
                <p className="legal-section__text">
                  Pour toute question concernant cette politique de confidentialité ou vos données 
                  personnelles, contactez-nous :
                </p>
                <div className="legal-contact-info">
                  <p><strong>Email :</strong> privacy@burotime.dz</p>
                  <p><strong>Téléphone :</strong> +213 560 60 56 55</p>
                  <p><strong>Téléphone :</strong> +213 560 39 42 54</p>
                  <p><strong>Adresse :</strong> Ouled Fayet; Alger, Algérie</p>
                </div>
              </div>
            </div>

            {/* Sidebar */}
            <aside className="legal-sidebar">
              <div className="legal-sidebar__card">
                <h3 className="legal-sidebar__title">Navigation Rapide</h3>
                <nav className="legal-sidebar__nav">
                  <a href="#" className="legal-sidebar__link">Introduction</a>
                  <a href="#" className="legal-sidebar__link">Données Collectées</a>
                  <a href="#" className="legal-sidebar__link">Utilisation des Données</a>
                  <a href="#" className="legal-sidebar__link">Partage des Données</a>
                  <a href="#" className="legal-sidebar__link">Sécurité</a>
                  <a href="#" className="legal-sidebar__link">Vos Droits</a>
                  <a href="#" className="legal-sidebar__link">Cookies</a>
                  <a href="#" className="legal-sidebar__link">Contact</a>
                </nav>
              </div>

              <div className="legal-sidebar__card">
                <h3 className="legal-sidebar__title">Documents Connexes</h3>
                <div className="legal-sidebar__links">
                  <Link to="/terms" className="legal-sidebar__doc-link">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
                      <polyline points="14 2 14 8 20 8"/>
                    </svg>
                    Conditions Générales
                  </Link>
                  <Link to="/cookies" className="legal-sidebar__doc-link">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
                      <polyline points="14 2 14 8 20 8"/>
                    </svg>
                    Politique de Cookies
                  </Link>
                  <Link to="/faq" className="legal-sidebar__doc-link">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <circle cx="12" cy="12" r="10"/>
                      <path d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3"/>
                      <line x1="12" y1="17" x2="12.01" y2="17"/>
                    </svg>
                    Questions Fréquentes
                  </Link>
                </div>
              </div>

              <div className="legal-sidebar__card legal-sidebar__card--highlight">
                <div className="legal-sidebar__icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                  </svg>
                </div>
                <h3 className="legal-sidebar__title">Besoin d'Aide?</h3>
                <p className="legal-sidebar__text">
                  Notre équipe est disponible pour répondre à toutes vos questions.
                </p>
                <Link to="/contact" className="legal-sidebar__btn">
                  Nous Contacter
                  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </Link>
              </div>
            </aside>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default PrivacyPolicy;